import Reveal from '../components/ui/Reveal.jsx';
import { RESULTS } from '../content/home.js';
import AccentedHeading from '../components/ui/Accent.jsx';

export default function ResultsBanner() {
  return (
    <section id="results" className="scroll-mt-24 bg-deep py-16 text-center lg:py-20">
      <div className="wrap">
        <h2 className="mb-10 font-display text-[24px] font-bold text-white lg:text-[30px]">
          <AccentedHeading text={RESULTS.heading} accent={RESULTS.accent} />
        </h2>

        <dl className="mx-auto grid max-w-[900px] grid-cols-2 gap-4 lg:grid-cols-4">
          {RESULTS.chips.map((c, i) => (
            <Reveal
              key={c.label}
              delay={Math.min(i, 5) * 60}
              className="rounded-xl border border-white/10 bg-white/[0.06] px-3.5 py-5"
            >
              <dt className="sr-only">{c.label}</dt>
              <dd>
                <b className="mb-1 block font-display text-[20px] text-amber lg:text-[24px]">
                  {c.value}
                </b>
                <span className="text-[12px] text-mist">{c.label}</span>
              </dd>
            </Reveal>
          ))}
        </dl>
      </div>
    </section>
  );
}
